(() => {
  'use strict';
  const dialog = document.getElementById('PfgWelcomeDialog');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const keys = { dismissed: 'pfg-welcome-dismissed-v1', subscribed: 'pfg-welcome-subscribed-v1', pending: 'pfg-welcome-pending-v1' };
  const read = (storage, key) => { try { return storage.getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, String(value)); } catch (_) { /* Storage may be unavailable. */ } };
  // Accessing storage itself can throw in privacy-restricted browsers.
  let local, session;
  try { local = window.localStorage; session = window.sessionStorage; } catch (_) { /* Keep the form usable without storage. */ }
  const visible = el => el !== dialog && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const otherOverlay = () => [...document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]')].some(visible)
    || Boolean(window.Shopify?.customerPrivacy?.shouldShowBanner?.());
  let automaticCancelled = false;
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    document.documentElement.classList.add('pfg-welcome-open');
  };
  const dismiss = () => {
    automaticCancelled = true;
    write(local, keys.dismissed, Date.now());
    dialog.close();
  };
  dialog.querySelectorAll('[data-pfg-welcome-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => document.documentElement.classList.remove('pfg-welcome-open'));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
  });
  document.querySelectorAll('[data-pfg-welcome-open]').forEach(button => button.addEventListener('click', () => { automaticCancelled = true; open(); }));
  const form = dialog.querySelector('form');
  form?.addEventListener('submit', () => write(session, keys.pending, Date.now()));
  const pendingAt = Number(read(session, keys.pending));
  const isReturn = new URLSearchParams(location.search).get('pfg_welcome') === '1' || (pendingAt > 0 && Date.now() - pendingAt < 30 * 60 * 1000);
  const success = Boolean(dialog.querySelector('[data-pfg-welcome-success]'));
  const error = Boolean(dialog.querySelector('[data-pfg-welcome-error]'));
  const returned = isReturn && (success || error);
  if (returned) {
    automaticCancelled = true;
    if (success) write(local, keys.subscribed, '1');
    write(session, keys.pending, '0');
  }
  const dismissedAt = Number(read(local, keys.dismissed));
  const dismissedRecently = Date.now() - dismissedAt < Number(dialog.dataset.dismissDays || 7) * 86400000;
  const eligible = dialog.dataset.auto === 'true' && !read(local, keys.subscribed) && !dismissedRecently && !window.Shopify?.designMode;
  if (!returned && !eligible) return;
  // Defer until the cookie/privacy dialog, cart modal, and any focused form are clear.
  const started = Date.now();
  const tryOpen = () => {
    if ((!returned && automaticCancelled) || Date.now() - started > 180000) return;
    const editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
    if (document.hidden || otherOverlay() || editing) { window.setTimeout(tryOpen, 1000); return; }
    open();
  };
  window.setTimeout(tryOpen, returned ? 300 : Number(dialog.dataset.delay || 8) * 1000);
})();
